<template>
    <ItemPage v-if="item" :m_item="item" />
</template>

<script>
import ItemPage from './item_page.vue';

export default {
  components: {
    ItemPage
  },
  data(){
    return {
      item: false
    }
  },
  mounted(){
    this.item = window.unpublishedItem;

    this.$store.user = window.unpublishedGeneral.user;
  }
}
</script>